export const starFilled = require("../assets/star.svg"); // Placeholder, assuming assets handled via require or URIs in this project structure
export const starOutline = require("../assets/star.svg");
export const userIcon = require("../assets/icon_avatar.svg");

// Since I cannot see the actual image files in the assets folder, and the previous file was empty. 
// I will provide SVG strings or URIs if the project uses them, but for React Native/Web compatibility implies specific asset handling.
// Based on `widget-loader.js` using SVGs, I will export SVGs here if `AddReview` supports them, 
// OR I will simply use the existing Material UI icons if the project allows (it does in web).
// However, `AddReview.tsx` imports from `react-native`, suggesting this is a React Native Web project.
// I will define simple URIs or utilize a library if available. 
// Given `EuDashboard` used `@material-ui/icons`, let's see if we can use those in `AddReview` (web specific) or if we need pure images.

// Let's stick to simple export for now and I will use icons from a library in the component.
export const imgStarFilled = "https://img.icons8.com/ios-filled/50/FFC107/star--v1.png";
export const imgStarOutline = "https://img.icons8.com/ios/50/000000/star--v1.png";
